export enum UploaderType {
    NatureMetrics = 'NatureMetrics',
    Client = 'Client',
}

export enum SiteFileType {
    ImageFiles = 'Image files',
    CsvAndxlsxFiles = 'CSV and XLSX files',
    PdfFiles = 'PDF files',
    OtherFiles = 'Other files',
}
